
const m = window.require("stream");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
